import React from 'react'
import TalentAppStep from "../components/TalentAppStep";
import UserImageCircle from "../../../components/UserImageCircle";
import {FormInputComponent} from "../../../components/form/Form";
import {Button, Checkbox, Select} from "antd";

const MAX_LINKS_COUNT = 8
export default class BioStep extends TalentAppStep {

    static path = '/bio';
    static LastUpdatedMethod = 'lastUpdatedBio';

    /**
     * The title shown on the form
     */
    static StepTitle = 'Bio';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = TB.trans('talent.bio.step_subtitle');
    /**
     * The start page info tile
     */
    static StepInfo = TB.trans('talent.bio.step_info');
    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Background';

    constructor(props) {
        super(props);
        this.nestedFormRefs = [React.createRef()];
        let links = TB.reduce(laravel.talent_profile_link_types || {}, (result, link, linkId) => {
            result.push({...link, value: linkId})
            return result
        }, []);
        let website = TB.find(links, ['name', 'Website']);
        links.unshift(website);
        let linkTypes =  TB.uniqBy(links, 'name');

        console.log('linktypesw', linkTypes)
        this.state = {...this.state, linkTypes}
    }

    static hasCompleted(user) {
        return user.validateBio();
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        let validProps = user.validateBio();
        if (validProps) {
            validProps.portfolio_url = user.portfolio_url
            validProps.portfolio_url_notes = user.portfolio_url_notes
        }
        return validProps;
    };

    /**
     * @param {User} user
     * @returns {Object}
     */
    static reviewMapping(user) {
        return {
            [TB.trans('talent.bio.review_mapping.my_title_label')]: user.job_title + '\n' + user.years_of_experience + " " + [TB.trans('talent.bio.review_mapping.years_exp')],
            [TB.trans('talent.bio.review_mapping.linkedin_url')]: user.linkedin_profile_url,
            [TB.trans('talent.bio.review_mapping.profile_photo')]: [(
                <UserImageCircle
                    key={'profile-review'}
                    user={user} hideTooltip={true} size={140} className="img-grayscale rounded-circle" />
            )],
            [TB.trans('talent.bio.review_mapping.bio_copy')]: user.bio
        }
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        const doesProfileContainDisciplineForPortfolio = this.props.user.shouldRequirePortfolioLink();

        let profileLinks = this.props.user.profile_links;
        let portfolioFields = []
        if (this.props.user.portfolio_url?.length) {
            portfolioFields.push({
                style: styles.fieldSection,
                fields: {
                    portfolio_url_has_notes_component: {
                        style: styles.field,
                        component: (
                            <FormInputComponent
                                type="antd-input"
                                label={false}
                                fieldName="portfolio_url_has_notes"
                                disabled={this.props.isDisabled}
                                value={this.props.user.portfolio_url_has_notes}
                            >
                                <Checkbox
                                    checked={this.props.user.portfolio_url_has_notes}>
                                    Include access instructions if needed
                                </Checkbox>
                            </FormInputComponent>
                        )
                    },
                }
            },)
        }
        if (this.props.user.portfolio_url_has_notes) {
            portfolioFields.push({
                style: styles.fieldSection,
                fields: {
                    portfolio_url_notes: {
                        label: false,
                        type: 'textarea',
                        maxLength: 500,
                        placeholder: 'Write here if the link requires password or other access information',
                        style: styles.field,
                        required: false,
                        rows: 3,
                        columns: 10
                    },
                }
            })
        }
        return [
            {
                style: styles.fieldSection,
                fields: {
                    job_title: {
                        label: TB.trans('talent.bio.job_title_label'),
                        placeholder: TB.trans('talent.bio.job_title_placeholder'),
                        required: true,
                        columns: 5,
                        maxLength: 100,
                        style: styles.field,
                    },
                    years_of_experience: {
                        type: 'number',
                        max: 100,
                        label: TB.trans('talent.bio.years_of_experience_label'),
                        required: true,
                        placeholder: TB.trans('talent.bio.years_of_experience_placeholder'),
                        style: styles.field,
                        columns: 5,
                        min: 0,
                        validation: {
                            rules: {
                                matchRegexp: /^[0-9][0-9]?$|^100$/,
                                isNumeric: true
                            },
                            errors: {
                                isNumeric: TB.trans('validation.numeric', {
                                    'attribute': 'years of experience'
                                }),
                                matchRegexp: TB.trans('talent.bio.years_of_experience_error_msg'),
                            }
                        }
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    linkedin_profile_url: {
                        label: `${TB.trans('talent.bio.linkedin_profile_url_label')} (Include https://)`,
                        placeholder: TB.trans('talent.bio.linkedin_profile_url_placeholder'),
                        type: 'url',
                        required: true,
                        maxLength: 255,
                        style: styles.field,
                        columns: 10
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    image_path: {
                        label: TB.trans('talent.bio.image_path_label'),
                        labelHint: String(this.props.user.image_path).includes('default-user') ? (
                            <span className="italic">
                                Uploading a profile image is highly recommended
                            </span>
                        ) : undefined,
                        type: 'pixie',
                        ratio: '1:1',
                        dropContainer: String(this.props.user.image_path).includes('default-user') ? (
                            <UserImageCircle user={this.props.user} hideTooltip={true} size={140} className="img-grayscale" />
                        ) : undefined,
                        maxWidth: 400,
                        // height: 150,
                        circular: true,
                        required: true,
                        style: styles.field,
                        columns: 8
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    bio: {
                        label: TB.trans('talent.bio.bio_label'),
                        placeholder: TB.trans('talent.bio.bio_placeholder'),
                        type: 'textarea',
                        required: true,
                        validationErrors: {
                            isDefaultRequiredValue: 'This field is required.'
                        },
                        style: styles.field,
                        maxLength: 2000,
                        columns: 8,
                        rows: 12
                    },
                }
            },

            // {
            //     style: styles.fieldSection,
            //     fields: {
            //         resume_path: {
            //             type: 'file',
            //             required: true,
            //             size: this.props.user?.resumeDocument()?.size,
            //             viewable: typeof this.props.user?.resume_path === 'string',
            //             label: 'Upload a PDF version of your resume (Required)',
            //             fileNameDisplay: (fileData) => {
            //                 return this.props.user?.resumeDocument()?.name || fileData.name;
            //             },
            //             validationErrors: {
            //                 isDefaultRequiredValue: 'Resume Upload is required'
            //             },
            //             style: styles.field,
            //             columns: 10
            //         },
            //     }
            // },
            {
                fields: {
                    spacer: {
                        component: (
                            <div style={{ flexBasis: '100%' }}>
                                <h5 className="form-header">Portfolio Link or Website</h5>
                                {doesProfileContainDisciplineForPortfolio && (
                                    <p className="form-subheader whitespace-pre-line">
                                        <span className="text-xs text-gray-600">
                                            <span className="font-bold">NOTE:&nbsp;</span>
                                            A Portfolio URL is required if you are in a Creative Role.
                                        </span>

                                        {!this.props.user.isApplicationApproved() && 'This must be added before you submit your application.'}

                                        &nbsp;You have signed up for the following Creative Role(s):&nbsp;

                                        <span
                                            className="font-semibold text-info">{TB.map(this.props.user.creativeRolesAdded(), 'name').join(', ')}</span>
                                    </p>
                                )}
                            </div>
                        )
                    }
                }
            },
            {
                style: {marginTop: '0.5rem', ...styles.fieldSection},
                fields: {
                    portfolio_url: {
                        label: `Portfolio URL (Include https://)`,
                        placeholder: 'Portfolio URL',
                        type: 'url',
                        className: 'field [&_.invalid-feedback]:relative',
                        required: doesProfileContainDisciplineForPortfolio,
                        maxLength: 255,
                        style: styles.field,
                        validationErrors: {
                            isDefaultRequiredValue: 'This field is required',
                            isURL: TB.trans('validation.active_url', {
                                'attribute': 'link',
                            })
                        },
                        columns: 10
                    },
                }
            },
            ...portfolioFields,
            {
                fields: {
                    spacer: {
                        component: (
                            <div className="basis-full mt-5">
                                <h5 className="form-header">External Sources (optional)</h5>
                                <p className="form-subheader whitespace-pre-line">
                                    <span className="text-xs text-gray-600">
                                       In addition to your LinkedIn and portfolio site, you may include other related links
                                        or documents to display in your profile.
                                    </span>
                                </p>
                            </div>
                        )
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    links_section: {
                        columns: 10,
                        component: (
                            <div className={"form-group"} style={styles.field}>
                                <label className="col-form-label flex flex-row items-center gap-7">
                                    <span>
                                        Related Links
                                    </span>
                                    {profileLinks?.length > 0 && (
                                        <span className={TB.mapClass("ml-auto text-xxs italic", {
                                            "opacity-7": profileLinks?.length < MAX_LINKS_COUNT,
                                            "text-danger font-semibold opacity-1": profileLinks?.length === MAX_LINKS_COUNT,
                                        })}>
                                            Max ({profileLinks?.length} / {MAX_LINKS_COUNT})
                                        </span>
                                    )}
                                </label>
                                <div className="flex flex-col gap-3">
                                    {TB.map(profileLinks, (link, index) => (
                                        <div key={`link-${index}`} className="flex flex-row items-center gap-1.5">
                                            <div className="flex flex-row items-center gap-2">
                                                {link.type_icon ? (
                                                    <i className={TB.mapClass(`fa-2x fa-${link.type_icon}`, {
                                                        "fab": link.type_icon.includes('fa-brand'),
                                                        "fas": !link.type_icon.includes('fa-brand')
                                                    })} style={{color: link.type_color}}/>
                                                ) : <i className="fa fa-link text-xxs text-gray-400"/>}

                                                <p className="text-xs font-medium">{link.type_name || 'Link'}</p>
                                            </div>

                                            <a href={link?.url} target="_blank"
                                               className="p-0 btn-link-info underline text-xs line-clamp-1">{link?.url}</a>

                                            <i className="fa fa-times text-danger clickable ml-2" onClick={() => {
                                                return this.onChange({
                                                    profile_links: TB.filter(profileLinks, l => l !== link)
                                                })
                                            }}/>
                                        </div>
                                    ))}
                                    {(!profileLinks?.length || profileLinks?.length < MAX_LINKS_COUNT) && (
                                        <div className="flex flex-row items-center self-stretch gap-2">
                                            <div className="form-links-input min-w-40">
                                                <FormInputComponent
                                                    fieldName={`newLinkType`}
                                                    value={this.props.user.newLinkType || null}
                                                    type="antd-input"
                                                    required={false}
                                                    validateBeforeSubmit={false}
                                                    label={false}
                                                    placeholder={"Select link type.."}
                                                >

                                                <Select value={this.props.user.newLinkType}>
                                                    {TB.map(this.state.linkTypes, (opt) => (
                                                        <Option key={`opt-${opt.name}`} value={parseInt(opt.value)}>
                                                            <span className="flex flex-row items-center gap-2">
                                                                <i className={TB.mapClass(`fa-${opt.icon}`, {
                                                                    "fab": opt.icon.includes('fa-brand'),
                                                                    "fas": !opt.icon.includes('fa-brand')
                                                                })} style={{color: opt.color}}/>
                                                                <span>{opt.name}</span>
                                                            </span>
                                                        </Option>
                                                    ))}

                                                </Select>
                                                </FormInputComponent>
                                            </div>
                                            <div className="flex-grow relative">
                                                <FormInputComponent
                                                    key={`new-link-input-${profileLinks?.length + 1}`}
                                                    fieldName="newLink"
                                                    type="url"
                                                    placeholder="https://example.com/newLink"
                                                    label={false}
                                                    value={this.props.user.newLink || ""}
                                                    required={false}
                                                />
                                            </div>
                                            <Button
                                                disabled={this.props.isDisabled || !this.props.user.newLinkType || !TB.isValidURLFormat(this.props.user.newLink || "")}
                                                onClick={async () => {
                                                    let matchedLink = TB.find(this.state.linkTypes, ['value', String(this.props.user.newLinkType)]);

                                                    if (!matchedLink) {
                                                        return;
                                                    }
                                                    await this.onChange({
                                                        profile_links: [...profileLinks, {
                                                            type_name: matchedLink.name,
                                                            type_icon: matchedLink.icon,
                                                            type_color: matchedLink.color,

                                                            url: this.props.user.newLink,
                                                            type: this.props.user.newLinkType,

                                                        }]
                                                    });
                                                    await this.formRef?.current?.updateInputsWithValue({newLink: undefined, newLinkType: undefined});
                                                }} type="default" className="text-xs flex flex-row gap-1.5"
                                                size="small">
                                                <i className="fa fa-plus ml-1"/>
                                                <span>Add Link</span>
                                            </Button>
                                        </div>
                                    )}

                                </div>
                            </div>
                        )
                    },
                }
            },
            {
                style: {...styles.fieldSection, marginTop: '2rem'},
                fields: {
                    profile_documents: {
                        label: "Related Documents (optional)",
                        type: 'multi-doc',
                        display_label: 'Key Visual',
                        accept: '.pdf,.doc,.docx,.txt,.xlsx,.xls,.csv,.ppt,.pptx',
                        mime: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
                        maxCount: 10,//MAX_DOC_ASSETS_COUNT,
                        required: false,
                        style: styles.field,
                        transformFiles: files => {
                            console.log('transformFiles', files)
                            return TB.map(files, (file) => {
                                if (!file.id) {
                                    return file;
                                }
                                return {
                                    ...file,
                                    uuid: file.id,
                                    type_id: file.type,
                                    type: file.extension,
                                    url: file.path
                                }
                            })
                        },
                        columns: 10
                    },
                }
            },
        ];
    };

    /**
     * Handles mapping
     *
     * @returns void
     * @param params
     */
    onChange(params) {

        let model = {}
        for (let [key, value] of Object.entries(params)) {
            model = TB.set(model, key, value)
        }

        if (model?.profile_links?.length) {
            model.profile_links = TB.map(model.profile_links, (link, i) => {
                if (TB.isDefined(link.display_index)) {
                    link.display_index = i + 1;
                }

                return link;
            })
        }

        if (!model.portfolio_url_has_notes && this.props.user.portfolio_url_has_notes && model.portfolio_url_notes?.length) {
            model.portfolio_url_notes = null;
        }

        // if(typeof model?.resume_path === 'object' && model.resume_path?.name) {
        //     model.resume_path.name = model.resume_path.path.name;
        // }
        let image_path = model.image_path;

        if (!image_path && this.props.user.image_path) {
            image_path = this.props.user.image_path;
        }


        return super.onChange({
            ...model,
            image_path
        })
    }

}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};